import React, { useEffect, useRef, useState } from "react";
import YouTube from "react-youtube";
import useVipMultiviewSoundStore from "../../../store/useVipMultiviewSoundStore";

const YouTubePlayer = ({ videoId, onEnded, onError, isSelected }) => {
  const { isMuted, volume } = useVipMultiviewSoundStore();
  const playerRef = useRef(null);
  const [isPlayerReady, setIsPlayerReady] = useState(false);
  const currentVideoId = useRef(videoId);

  const opts = {
    height: "100%",
    width: "100%",
    playerVars: {
      // https://developers.google.com/youtube/player_parameters
      autoplay: 1,
      mute: 1, // Start muted by default, we'll update it after player loads
      controls: 0,
      modestbranding: 1,
      rel: 0,
      playsinline: 1,
      enablejsapi: 1,
    },
  };

  // Track when videoId changes to reset ready state
  useEffect(() => {
    // If video ID changed, mark player as not ready
    if (currentVideoId.current !== videoId) {
      // console.log("Video ID changed, resetting player ready state");
      setIsPlayerReady(false);
      currentVideoId.current = videoId;
    }
  }, [videoId]);

  // Update player volume and mute state whenever selection, volume or global mute changes
  // BUT only if the player is fully ready for the current video
  useEffect(() => {
    // console.log("Effect was triggered, isPlayerReady:", isPlayerReady);
    if (
      playerRef.current &&
      playerRef.current.internalPlayer &&
      isPlayerReady
    ) {
      // console.log("Player is ready");
      const player = playerRef.current.internalPlayer;

      // Set volume (YouTube API uses 0-100)
      if (isSelected) {
        player.setVolume(volume);
      }

      // Only play audio if this player is selected AND global mute is off
      if (isSelected && !isMuted) {
        player.unMute();
      } else {
        player.mute();
      }
    }
  }, [isSelected, isMuted, volume, isPlayerReady]);

  const handleReady = (event) => {
    // console.log("Player ready: ", event);
    // When player is ready, set the initial mute state based on selection

    const player = event.target;

    // Set initial volume
    if (isSelected) {
      player.setVolume(volume);
    }

    // Only unmute if this is the selected player AND global mute is off
    if (isSelected && !isMuted) {
      player.unMute();
    } else {
      player.mute();
    }

    // Mark player as ready for this specific video
    setIsPlayerReady(true);
  };

  return (
    <div
      style={{
        position: "relative",
        height: "100%",
        width: "100%",
      }}
    >
      <YouTube
        ref={playerRef}
        videoId={videoId}
        opts={opts}
        style={{
          width: "100%",
          height: "100%",
        }}
        onEnd={() => {
          console.warn("VIDEO ENDED");
          if (onEnded) onEnded(videoId);
        }}
        onError={(error) => {
          console.log("Error: ", error);
          if (onError) onError(error, videoId);
        }}
        onPlay={handleReady}
      />
    </div>
  );
};

export default YouTubePlayer;
